module.exports = __webpack_public_path__ + "71bb648c3b543fd7c4f2628fa14a350d.ttf";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fino/ng1-signature-pad/resources/ApplauseFont.ttf
// module id = 45
// module chunks = 12